
export const personalVideo = {
  title: "SZEMÉLYES VIDEÓÜZENET",
  subtitle: "Egyedi, személyre szabott videóüzenet közvetlenül tőlem, különleges alkalmakra vagy motivációs célból.",
  backButton: "Vissza Pumped Gabo oldalára",
  choosePlan: "VÁLASSZ VIDEÓÜZENET CSOMAGOT",
  planDescription: "Válaszd ki a számodra megfelelő videóüzenet csomagot és nyűgözd le szeretteidet vagy barátaidat egy személyre szabott üzenettel tőlem. Bármilyen alkalomra tökéletes meglepetés!",
  deliveryTime: "Elkészítési idő:",
  chooseButton: "Választom",
  howItWorks: "HOGYAN MŰKÖDIK?",
  step1: "Válaszd ki a megfelelő videóüzenet csomagot a fenti lehetőségek közül.",
  step2: "Töltsd ki a megrendelő űrlapot, hogy pontosan tudjam, milyen üzenetet szeretnél és kinek szól.",
  step3: "Fizesd ki a megrendelést és a megadott határidőn belül elkészítem a személyre szabott videóüzenetet.",
  step4: "A videót a megadott e-mail címre küldöm, ahonnan egyszerűen letöltheted és továbbíthatod az ajándékozottnak.",
  orderForm: {
    title: "VIDEÓÜZENET MEGRENDELÉSE",
    backToPlan: "Vissza a csomagokhoz",
    recipientSection: "Kinek szól a videó?",
    recipientName: "Címzett neve",
    recipientNamePlaceholder: "Pl. Kiss János",
    recipientAge: "Címzett életkora (opcionális)",
    recipientAgePlaceholder: "Pl. 25",
    occasionSection: "Mi legyen a videóban?",
    occasion: {
      birthday: "Születésnap",
      nameday: "Névnap",
      anniversary: "Évforduló",
      motivation: "Motiváció edzéshez",
      graduation: "Ballagás/Diplomaosztó",
      wedding: "Esküvő/Eljegyzés", 
      congratulation: "Gratuláció",
      apology: "Bocsánatkérés",
      celebration: "Ünneplés/Buli",
      prank: "Vicces átverés",
      other: "Egyéb"
    },
    instructionsLabel: "Mit mondjak a videóban? (Add meg részletesen)",
    instructionsPlaceholder: "Pl. Köszöntsd Jánost a 30. születésnapján, és adj neki motivációt az edzéseihez...",
    instructionsHelp: "Max. 500 karakter. Írd le részletesen, mit szeretnél, hogy mondjak.",
    yourDataSection: "Rendelési adatok",
    yourName: "Teljes neved",
    yourNamePlaceholder: "Add meg a teljes neved",
    yourEmail: "Email címed",
    yourEmailPlaceholder: "pelda@email.hu",
    emailHelp: "Az elkészült videót erre az e-mail címre küldjük.",
    submitButton: "Megrendelés és fizetés",
    termsAgreement: "A megrendelés elküldésével elfogadod a felhasználási feltételeket és az adatvédelmi irányelveket.",
    orderSuccess: "Megrendelés elküldve!",
    orderSuccessDesc: "Köszönjük a megrendelést! Hamarosan elkészítjük a videóüzenetet."
  }
};
